import React from 'react'
import Header from '../components/Header';
import TinderCards from "../components/TinderCards";

export const HomePage = () => {
    return (
        <>
            <Header />
            <TinderCards />
        </>
    )
}
